import WEBAPI from '../../services/WEBAPI';
import * as ATypes from '../../shared/actionTypes';
import { getDerivedAuthority } from '../authoritySelection/utilities';

const getPaymentDetailsLoading = (loading) => ({
  type: ATypes.GET_PAYMENT_DETAILS_LOADING,
  payload: loading,
});

const getPaymentDetailsSuccess = (paymentDetails) => ({
  type: ATypes.GET_PAYMENT_DETAILS_SUCCESS,
  payload: paymentDetails,
});

const getPaymentDetailsError = (error) => ({
  type: ATypes.GET_PAYMENT_DETAILS_ERROR,
  payload: error,
});

export const getPaymentDetails = (code) => {
  return async (dispatch, getState) => {
    const store = getState();
    const authority = getDerivedAuthority(store);

    dispatch(getPaymentDetailsLoading(true));

    if (!authority) {
      dispatch(getPaymentDetailsLoading(false));
      return Promise.reject(new Error('Authority not found'));
    }

    if (!code) {
      dispatch(getPaymentDetailsLoading(false));
      return Promise.reject(new Error('Code not found'));
    }

    try {
      const res = await WEBAPI.getPaymentDetailsRequest(authority, code);
      dispatch(getPaymentDetailsSuccess(res.result || {}));
      return res.result || {};
    } catch (error) {
      console.log('Failed to get payment details:', error);
      dispatch(getPaymentDetailsError(error));
      return Promise.reject(error);
    } finally {
      dispatch(getPaymentDetailsLoading(false));
    }
  };
};

export const preparePaymentLoading = (loading) => ({
  type: ATypes.PREPARE_PAYMENT_LOADING,
  payload: loading,
});

export const makePaymentLoading = (loading) => ({
  type: ATypes.MAKE_PAYMENT_LOADING,
  payload: loading,
});

export const makePaymentSuccess = (paymentData) => ({
  type: ATypes.MAKE_PAYMENT_SUCCESS,
  payload: paymentData,
});

export const makePaymentError = (error) => ({
  type: ATypes.MAKE_PAYMENT_ERROR,
  payload: error,
});

export const makePayment = (paymentId) => {
  return async (dispatch, getState) => {
    const store = getState();
    const authority = getDerivedAuthority(store);

    if (!authority) {
      return Promise.reject(new Error('Authority not found'));
    }

    try {
      dispatch(makePaymentLoading(true));
      const res = await WEBAPI.makePaymentWithoutCard(authority, paymentId);

      dispatch(makePaymentSuccess(res.result?.auth?.authorization_url || ''));

      return res.result?.auth?.authorization_url || '';
    } catch (error) {
      dispatch(makePaymentError(error));
      return Promise.reject(error);
    } finally {
      dispatch(makePaymentLoading(false));
    }
  };
};

export const preparePaymentSuccess = (paymentData) => ({
  type: ATypes.PREPARE_PAYMENT_SUCCESS,
  payload: paymentData,
});

export const preparePaymentError = (error) => ({
  type: ATypes.PREPARE_PAYMENT_ERROR,
  payload: error,
});

export const preparePayment = (data) => {
  return async (dispatch, getState) => {
    const store = getState();
    const authority = getDerivedAuthority(store);

    if (!authority) {
      return Promise.reject(new Error('Authority not found'));
    }

    try {
      dispatch(preparePaymentLoading(true));
      const res = await WEBAPI.preparePaymentRequest(authority, data);

      await dispatch(preparePaymentSuccess(res.result || {}));

      return await dispatch(
        makePayment(res.result?.payment_id || data.payment_id)
      );
    } catch (error) {
      dispatch(preparePaymentError(error));
      return Promise.reject(error);
    } finally {
      dispatch(preparePaymentLoading(false));
    }
  };
};
